//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
import listRequest from '../../js/listRequest.js';

export const statisticsApi = {
    //最简单的写法，列表啥也不用做
    getAccountData(opt: any) {
        var servicesPath = baseURL + '/v1/stat/user';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '查询中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getCourseData(opt: any) {
        var servicesPath = baseURL + '/v1/stat/course';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '查询中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    getCourseOverview(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/course/overview';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getWorkOverview(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/work/overview';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getAccountOverview(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/account/overview';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 获取学习进度
    getLearningProgress(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/study/plan';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getTeacherClassCount(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/teacher/start/class/count';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getTeacherClassTime(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/teacher/start/class/time';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 批改作品率和优秀率
    getWorkRate(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/work/correct/result';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 实验作品类型
    getExperimentWork(opt: any) {
        var servicesPath = baseURL + '/v1/school/statistics/commit/work/type';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getAuthorizeCourseList(opt: any) {
        var servicesPath = baseURL + '/distribution/courses/' + opt.courseId;
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getSchoolDistributionCourse(opt: any) {
        let urlQueryParmas = opt.urlQueryParmas || {};
        var servicesPath = baseURL + '/distribution/school/' + urlQueryParmas.schoolId;
        let context = opt.context;
        delete urlQueryParmas.schoolId;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') opt.error(error, message, parameters);
            }
        });
    },
    getCodes(opt: any) {
        var servicesPath = baseURL + '/aicp-system/v1/system/code/getByCodes';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {codes: 'web-top-help,test_platform,entry_type,learning_section'};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载中，请稍等...',
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
